import React from "react";
import StandardView from "../FormGroup/StandardView";
const ReadonlyFormGroup = (props) => (<StandardView label={props.label} className={props.className}>
		<div className="textInput">
			{props.value || "\u00A0"}
		</div>
	</StandardView>);
export default ReadonlyFormGroup;



// WEBPACK FOOTER //
// ./src/assets/scripts/components/common/form/ReadonlyFormGroup/ReadonlyFormGroup.tsx